import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Block, ResponsiveTable, Thead, Th, Tr, Td } from "commons";
import { grossOrNet, formatChartMoney } from "commons/src/ChartFunctions";
import { InfoPopover, InfoDetail, useInfoPopover } from "commons/src/InfoPopover";

import { getDescription } from "../../components/AccountDetailDescription";

export function ValVsMimoTable({ account, data }) {
    const [anchorElement, popoverContent, openInfoPopover, closeInfoPopover] = useInfoPopover();

    const buildTable = (data, account) => {
        const valTableData = data.tableBreakdown.length
            ? data.tableBreakdown.find(obj => Object.keys(obj)[0] === account)[account]
            : [];
        const mimoTableData = data.valVsMimoTablebreakdown.length
            ? data.valVsMimoTablebreakdown.find(obj => Object.keys(obj)[0] === account)[account]
            : [];

        return (
            <div data-testid="val-vs-mimo-table">
                <ResponsiveTable>
                    {buildTableHead(valTableData)}
                    <tbody>
                        {buildTableRow(valTableData, "Valuation")}
                        {buildTableRow(
                            mimoTableData,
                            "Payments / Withdrawals " + grossOrNet(data.netOfFeesText)
                        )}
                    </tbody>
                </ResponsiveTable>
                {data.netOfFeesText && <div>{data.netOfFeesText}</div>}
            </div>
        );
    };

    const buildTableHead = accountData => {
        return (
            <Thead>
                <Tr>
                    <Th />
                    {accountData
                        .reduce((a, b) => a.concat(Object.keys(b)[0]), [])
                        .map(header => header.replace(/\//g, "-"))
                        .map(header => (
                            <Th key={header}>{header}</Th>
                        ))}
                </Tr>
            </Thead>
        );
    };

    const buildTableRow = (breakdown, rowTitle) => {
        const cells = breakdown.map(datapoint => {
            const key = Object.keys(datapoint)[0];
            return (
                <Td key={key} data-label={key} align="right">
                    {formatChartMoney(datapoint[key])}
                </Td>
            );
        });

        return (
            <Tr>
                <ResponsiveTd key={rowTitle} align="left">
                    {rowTitle.includes("Payments / Withdrawals") ? (
                        <InfoDetail
                            onClick={e =>
                                openInfoPopover(e, getDescription("Payments / Withdrawals"))
                            }
                        >
                            {rowTitle}
                        </InfoDetail>
                    ) : (
                        rowTitle
                    )}
                </ResponsiveTd>
                {cells}
            </Tr>
        );
    };

    return (
        <Block>
            <InfoPopover
                handleClose={closeInfoPopover}
                anchorEl={anchorElement}
                content={popoverContent}
                horizontalPosition="left"
            />
            {buildTable(data, account)}
        </Block>
    );
}

export const ResponsiveTd = styled(Td)`
    @media (max-width: ${props => props.theme.maxWidth}) {
        color: ${props => props.theme.primary};
        border-bottom: 1px solid ${props => props.theme.primary} !important;
    }
`;

ValVsMimoTable.propTypes = {
    account: PropTypes.string,
    data: PropTypes.object
};
